// extracted by mini-css-extract-plugin
export default {"link":"Link-module_link__T0104"};